// Separated as a function to be mocked in tests
export default function hasFocus(element: HTMLElement | null) {
  return element?.contains(document.activeElement) || false;
}
